export default "__VITE_ASSET__Ba_a2afI__"